import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import RadioActive from "shared/assets/Radio_Active.svg";
import RadioInactive from "shared/assets/Radio_Inactive.svg";
import styles from "./ImageRadioOption.module.css";

export function ImageRadioOption({
  checked,
  label,
  className,
  iconClassName,
  labelClassName,
}) {
  return (
    <span className={classNames(styles.container, className)}>
      <img
        className={classNames(styles.icon, iconClassName)}
        src={checked ? RadioActive : RadioInactive}
        alt=""
        aria-hidden="true"
      />
      <span className={classNames(styles.label, labelClassName)}>{label}</span>
    </span>
  );
}

ImageRadioOption.propTypes = {
  checked: PropTypes.bool,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  iconClassName: PropTypes.string,
  labelClassName: PropTypes.string,
};

ImageRadioOption.defaultProps = {
  checked: false,
  className: undefined,
  iconClassName: undefined,
  labelClassName: undefined,
};

export default ImageRadioOption;
